import {
  IListVendor,
  IUpdateStatus,
  IUpdateApproval,
  IAddVendor,
  IEditVendor,
} from "../../types/request_data/vendors";
export const vendorJSON = {
  listVendor: ({
    pageNo,
    limit,
    sortKey,
    sortOrder,
    searchTerm,
    // classDepth,
    // state,
    category,
    selectedSubCategory,
  }: IListVendor) => {
    const data: any = {
      pageNo: pageNo,
      limit: limit ? limit : "",
      sortKey: sortKey,
      sortOrder: sortOrder,
      needCount:  true,
      searchTerm: searchTerm,
      // classDepth: classDepth,
      // state: state,
      category: category,
    };
    selectedSubCategory?.map((val: any, index: number) => {
      data["subCategory[" + index + "]"] = val.value;
    });
    return data;
  },
  updateStatus: (status: IUpdateStatus) => {
    return { status: status };
  },
  updateApproval: (status: IUpdateApproval) => {
    return { status: status };
  },
  addVendor: (profileData: IAddVendor) => {
    const vendor = {
      businessName: profileData.businessName,
      name: profileData.VendorName,
      phone: profileData.phone,
      phoneCountry: profileData.phoneCountry,
      email: profileData.email,
      locality: profileData.buildingNumber,
      address: profileData.address,
      image: profileData.image.split(".com/")[1],
      bannerImage: profileData.bannerImage.split(".com/")[1],
      category: profileData.Category._id,
      lat: profileData.lat,
      lng: profileData.lng,
      thumbnail: profileData.thumbnail.split(".com/")[1],
      bannerThumbnail: profileData.bannerImageThumbnail.split(".com/")[1],
      subCategory: profileData?.SubCategory?.map((val: any) => ({
        reference: val.value,
      })),
    };
    return vendor;
  },

  editVendor: (profileData: IEditVendor) => {
    const data: any = {
      businessName: profileData.businessName,
      name: profileData.VendorName,
      phone: profileData.phone,
      phoneCountry: profileData.phoneCountry,
      email: profileData.email,
      locality: profileData.buildingNumber,
      address: profileData.address,
      image: profileData.image.split(".com/")[1],
      bannerImage: profileData.bannerImage.split(".com/")[1],
      category: profileData.Category._id,
      lat: profileData.lat,
      lng: profileData.lng,
      thumbnail: profileData.thumbnail.split(".com/")[1],
      bannerThumbnail: profileData.bannerImageThumbnail.split(".com/")[1],
      subCategory: profileData?.SubCategory?.map((val: any) => ({
        reference: val.value,
      })),
    };
    // profileData?.SubCategory?.map((val: any, index: number) => {
    //   data["subCategory[" + index + "][reference]"] = val.value;
    // });
    return data;
  },
  updateServiceStatus: (status: IUpdateStatus) => {
    return { status: status };
  },
};
